module.exports = __webpack_public_path__ + "static/media/IMG_1278.722c8b27.JPG";